module.exports = __webpack_public_path__ + "static/media/img10.774de278.jpg";